import Vue from 'vue';
import { Module } from 'vuex';

import { Optional, RootState } from 'frontend/types';
import { PaymentReturn } from 'frontend/types/premium/index';

const paymentReturn: Module<PaymentReturn, RootState> = {
  namespaced: true,
  state: {
    is_subscribed: false,
    plan_interval: null,
    subscription_id: null,
    total_price: null,
    total_price_usd: null,
    country: null,
  },
  mutations: {
    setValue(state: PaymentReturn, value: Optional<PaymentReturn>) {
      if (value) {
        Object.entries(value).forEach(([k, v]) => {
          Vue.set(state, k, v);
        });
      }
    },
  },

  actions: {
    update({ commit }, newState: PaymentReturn) {
      commit('setValue', newState);
    },
  },
  getters: {
    paymentReturn: (state: PaymentReturn) => state,
  },
};

export default paymentReturn;
